import { type Attribute } from '@/common/types/attribute.type';
import { useQuery } from '@tanstack/react-query';
import Client from '@/common/utils/client.utility';

export type GetProductAttributeById = (id: number) => Promise<{
  data: Attribute[];
}>;

const getProductAttributeById: GetProductAttributeById = async (id: number) => {
  const client = new Client();

  return await client.get(`/v1/ProductAttribute/product/${id}`);
};

export function useGetProductAttributeById({ id }: { id: number }) {
  return useQuery({
    queryKey: ['Product-Attribute', id],
    queryFn: async () => await getProductAttributeById(id),
  });
}
